import { NAVIGATOR_CONFIG } from "../../headless/children";
function StackHeaderRight(_props) {
  return null;
}
Object.assign(StackHeaderRight, {
  [NAVIGATOR_CONFIG]: true
});
function appendStackHeaderRightPropsToOptions(options, props) {
  if (!props.asChild) {
    return options;
  }
  return {
    ...options,
    headerRight: function headerRight() {
      return props.children;
    }
  };
}
export {
  StackHeaderRight,
  appendStackHeaderRightPropsToOptions
};
//# sourceMappingURL=StackHeaderRight.js.map
